<template>
  <v-card :class="['v-feedback', state === 'default' && 'v-feedback--idle']">
    <div class="v-feedback__wrapper">
      <div class="v-feedback__content">
        <slot v-if="state === 'default'"></slot>
        <slot v-if="state === 'positive'" name="positive"></slot>
        <slot v-if="state === 'negative'" name="negative"></slot>
      </div>
      <div class="v-feedback__smileys">
        <div
          @click="state === 'default' && (state = 'positive')"
          :class="[
            'v-feedback__smileys__positive',
            state === 'positive' && 'v-feedback__smileys__positive--active'
          ]"
        >
          <svg width="26" height="26" xmlns="http://www.w3.org/2000/svg">
            <g
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M21.485 4.515c4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97 4.686-4.687 12.284-4.687 16.97 0"
              />
              <path
                d="M9 9.4a.4.4 0 1 1-.4.4c0-.22.18-.4.4-.4M17 9.4a.4.4 0 1 1-.4.4c0-.22.179-.4.4-.4M19.008 16.973a7.203 7.203 0 0 1-12.006.02"
              />
            </g>
          </svg>
        </div>
        <div
          @click="state === 'default' && (state = 'negative')"
          :class="[
            'v-feedback__smileys__negative',
            state === 'negative' && 'v-feedback__smileys__negative--active'
          ]"
        >
          <svg width="26" height="26" xmlns="http://www.w3.org/2000/svg">
            <g
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M21.485 4.515c4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97 4.686-4.687 12.284-4.687 16.97 0M18.982 18.588a7.204 7.204 0 0 0-11.92-.07"
              />
              <path
                d="M9 9.4a.4.4 0 1 1-.4.4c0-.22.18-.4.4-.4M17 9.4a.4.4 0 1 1-.4.4c0-.22.179-.4.4-.4"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      state: "default"
    };
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-feedback {
  &__wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  &__content {
    flex: auto;
    margin-right: $spacer;
  }

  &__smileys {
    margin-bottom: auto;
    display: flex;
    justify-content: center;
    max-height: 26px;
    color: theme-color("dark");

    &__positive,
    &__negative {
      display: inline-block;
    }

    &__positive {
      margin-right: $spacer * 0.5;

      .v-feedback--idle & {
        cursor: pointer;
      }

      .v-feedback--idle &:hover {
        * {
          color: theme-color("success");
        }
      }

      &--active {
        * {
          color: theme-color("success");
        }
      }
    }

    &__negative {
      .v-feedback--idle & {
        cursor: pointer;
      }

      .v-feedback--idle &:hover {
        * {
          stroke: theme-color("danger");
        }
      }

      &--active {
        * {
          stroke: theme-color("danger");
        }
      }
    }
  }

  @media print {
    display: none !important;
  }
}
</style>
